import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import { useAuth } from "../../context/AuthContext";
import { Award, BookOpenText, Box, LogOut, MessagesSquare, User2 } from "lucide-react";

export default function Menu() {
    const navigate = useNavigate();
    const location = useLocation();
    const { logout } = useAuth();

    const handleLogout = async () => {
        await logout();
        toast.success("با موفقیت خارج شدید");
        navigate("/login");
    };

    const menuItems = [
        { path: "/products", label: "محصولات", icon: <Box className="size-5 tablet:size-[18x]" /> },
        { path: "/catalog", label: "کاتالوگ", icon: <BookOpenText className="size-5 tablet:size-[18x]" /> },
        { path: "/certifications", label: "گواهینامه‌ها", icon: <Award className="size-5 tablet:size-[18x]" /> },
        { path: "/messages", label: "پیام‌ها", icon: <MessagesSquare className="size-5 tablet:size-[18x]" /> },
        { path: "/account", label: "حساب کاربری", icon: <User2 className="size-5 tablet:size-[18x]" /> },
    ];

    return (
        <div className="w-full min-h-screen flex bg-foreground text-background">
            <aside className="w-20 tablet:w-64 h-screen bg-gradient-to-br from-background to-[#222] border-l border-white/10 flex flex-col p-4 tablet:p-6 sticky top-0">
                <div className="flex items-center justify-center tablet:justify-start gap-2 mb-8">
                    <img
                        src="/logo.png"
                        alt="fanavaran borna"
                        className="size-8 object-contain grayscale"
                    />
                    <h1 className="hidden tablet:block text-lg font-semibold text-white">فن‌آوران برنا</h1>
                </div>

                <nav className="flex-1 flex flex-col gap-1">
                    {menuItems.map((item) => {
                        const path = location.pathname;
                        const isActive =
                            item.path === "/products"
                                ? ["/products", "/create-product", "/edit-product"].some((p) =>
                                    path.startsWith(p)
                                )
                                : path === item.path;

                        return (
                            <NavLink
                                key={item.path}
                                to={item.path}
                                className={`flex items-center justify-center aspect-square tablet:aspect-auto tablet:justify-start gap-2 tablet:px-4 tablet:py-2 rounded-lg text-foreground transition-colors ${isActive
                                        ? "bg-gradient-to-br from-white/15 to-white/30 font-medium border border-white/30"
                                        : "bg-transparent hover:bg-white/10"
                                    }`}
                            >
                                {item.icon}
                                <span className="hidden tablet:inline">{item.label}</span>
                            </NavLink>
                        );
                    })}
                </nav>

                <button
                    onClick={handleLogout}
                    className="mt-auto flex aspect-square tablet:aspect-auto items-center justify-center tablet:justify-start gap-2 tablet:px-4 tablet:py-2 rounded-lg text-white/70 hover:text-white hover:bg-white/10 transition-colors"
                >
                    <LogOut className="size-5 tablet:size-[18px]" />
                    <span className="hidden tablet:inline">خروج</span>
                </button>
            </aside>

            <main className="flex-1 p-6 overflow-y-auto">
                <Outlet />
            </main>
        </div>
    );
}